import {Routes} from '@angular/router';
import {CnConfigPage} from './page/cn-config-page/cn-config.page';
import {CnModelComparisonPage} from './page/cn-model-comparison-page/cn-model-comparison.page';
import {CnDashboardPage} from './page/cn-dashboard-page/cn-dashboard.page';
import {CnReconciliationPage} from './page/cn-reconciliation-page/cn-reconciliation.page';
import {CnImportPage} from './page/cn-import-page/cn-import.page';
import {CnImportReviewPage} from './page/cn-import-review-page/cn-import-review.page';
import {CnCommissionModelObjectPage} from './page/cn-commission-model-object-page/cn-commission-model-object.page';
import {CnCommissionRuleObjectPage} from './page/cn-commission-rule-object-page/cn-commission-rule-object.page';
import {CnCommissionStatementObjectPage} from './page/cn-commission-statement-object-page/cn-commission-statement-object.page';
import {CnContractCommissionPage} from './page/cn-contract-commission-page/cn-contract-commission.page';

/**
* Route declarations for the cn (Commission iNcome) module.
* Registered in feature-prov.routing.module.ts via getRouters().
*
* All paths use the cn/ prefix; only Page components are routed.
* CONFIG-001: exactly one config route (cn/config).
*/
export function CnSubRoutes(): Routes {

    /**
    * path:
    * Prefix of the module will always be added to the path name.
    *
    * canActivate:
    * The authentication guard MsalGuard will be added automatically.
    *
    * component:
    * Added components must be of type 'Page'.
    */
    const routes: Routes = [
        {path: 'cn/config', component: CnConfigPage},
        {path: 'cn/dashboard', component: CnDashboardPage},
        {path: 'cn/import', component: CnImportPage},
        {path: 'cn/import-review', component: CnImportReviewPage},
        {path: 'cn/reconciliation', component: CnReconciliationPage},
        {path: 'cn/model-comparison', component: CnModelComparisonPage},
        {path: 'cn/commission-model/:id', component: CnCommissionModelObjectPage},
        {path: 'cn/commission-rule/:id', component: CnCommissionRuleObjectPage},
        {path: 'cn/commission-statement/:id', component: CnCommissionStatementObjectPage},
        {path: 'cn/contract/:contractId/commission', component: CnContractCommissionPage},
    ];

    return routes;

}
